import { Component, Input, Output } from '@angular/core';
import { BaseComponent } from '../base/base/base-component.component';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-open-delete',
    template: `
        <div class="d-flex flex-row gap-1">
            <button class="d-flex gap-2 align-items-center btn action-button" (click)="onViewItem()">
                <img class="icon" src="@imagesDir/view.png" />
            </button>
            <button class="d-flex gap-2 align-items-center btn action-button" (click)="onDeleteItem()">
                <img class="icon" src="@imagesDir/cross.png" />
            </button>
        </div>
    `,
    styles: [
        `
            .icon {
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
        `,
    ],
    standalone: false,
})
export class OpenDeleteComponent extends BaseComponent {
    @Output()
    emitter = new Subject<{ action: string; data: any }>();

    @Input()
    data: any = {};

    ngOnInit() {}

    onViewItem() {
        this.emitter.next({
            action: 'view',
            data: this.data,
        });
    }

    onDeleteItem() {
        this.emitter.next({
            action: 'delete',
            data: this.data,
        });
    }
}
